import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add, ContentCopy } from '@mui/icons-material';

interface QuestionsEditorHeaderProps {
    title: string;
    questionsExist: boolean;
    onCancel: () => void;
    onCopyQuestions?: () => void;
    handleAddQuestion: () => void;
}

/**
 * Question editor header.
 */
const QuestionsEditorHeader: React.FC<QuestionsEditorHeaderProps> = ({
    title,
    questionsExist,
    onCancel,
    onCopyQuestions,
    handleAddQuestion,
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography variant="h3">{title}</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {questionsExist && onCopyQuestions && (
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<ContentCopy />}
                        onClick={onCopyQuestions}
                        sx={{ minWidth: 'auto' }}
                    >
                        Copy questions
                    </Button>
                )}
                <Button variant="contained" color="primary" size="small" startIcon={<Add />} onClick={handleAddQuestion}>
                    Add another question
                </Button>
                <Button variant="outlined" color="primary" size="small" onClick={onCancel} sx={{ minWidth: 'auto' }}>
                    Cancel
                </Button>
            </Box>
        </Box>
    );
};

export default QuestionsEditorHeader;
